export default "<p>crop-yield-sidebar works!</p>\n"